





























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Countries } from '@questelservices/common';
import { PageTitle } from '@questelservices/common-vue';
import { DxButton } from 'devextreme-vue';
import DxForm, {
  DxSimpleItem,
  DxButtonItem,
  DxButtonOptions,
  DxRequiredRule,
  DxPatternRule,
  DxEmailRule
} from 'devextreme-vue/form';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import { HelpFormDto } from '../models/help/HelpFormDto';
import { HelpService } from '../service/HelpService';

@Component({
  components: {
    PageTitle,
    DxButton,
    DxForm,
    DxSimpleItem,
    DxButtonItem,
    DxButtonOptions,
    DxRequiredRule,
    DxPatternRule,
    DxEmailRule,
    DxLoadIndicator
  }
})
export default class Help extends Vue {
  private isSubmitting: boolean = false;
  private submitted: boolean = false;
  private errorMessage: string = '';
  private helpService: HelpService = new HelpService();

  @Prop({ default: 'Help' })
  public readonly title!: string;

  private get formData(): HelpFormDto {
    return {
      FirstName: '',
      LastName: '',
      Company: '',
      Email: '',
      Message: ''
    };
  }

  private get countryEditorOptions() {
    return {
      dataSource: this.countries,
      displayExpr: 'Name',
      searchEnabled: true,
      searchExpr: 'Name',
      valueExpr: 'Name'
    };
  }

  private get countries() {
    return Countries;
  }

  private onEmailSupport(e: any): void {
    window.open('mailto:QuestelServicesSupport@questel.com?subject=Questel%20Services%20Support%20Request', '_self');
  }

  private onSubmit(e: any): void {
    this.errorMessage = '';
    this.isSubmitting = true;

    this.helpService.SubmitForm(this.formData)
      .then(this.handleSuccessfulSubmission)
      .catch(this.handleFailedSubmission)
      .finally(() => {
        this.isSubmitting = false;
      });

    e.preventDefault();
  }

  private get form() {
    return (this.$refs['form'] as any).instance;
  }

  private handleSuccessfulSubmission(): void {
    if (this.form) {
      this.form.resetValues();
    }
    
    this.submitted = true;
  }

  private handleFailedSubmission(result: any): void {
    this.errorMessage = result.Message ? result.Message : 'An error occurred while submitting the form.';
  }
}
